<template>
	<div class="ao-tab-links">
		<div class="ao-tab-links__panel">
			<router-link
				v-for="item in links"
				:key="item[itemValue]"
				:to="item.to"
				class="ao-tab-links__panel-item ao-p3-medium"
			>
				{{ item[itemTitle] }}
			</router-link>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	items: {
		type: Array,
		default: () => ([]),
	},
	itemTitle: {
		type: String,
		default: 'title'
	},
	itemValue: {
		type: String,
		default: 'value'
	},
})

const links = computed(() => {
	return props.items
})
</script>

<style lang="scss">
.ao-tab-links {
	&__panel {
		display: flex;
		align-items: stretch;

		&-item {
			display: flex;
			align-items: center;
			color: rgb(var(--v-theme-textSecondary700));
			padding: 8px 12px;
			transition: all .2s linear;
			border-radius: 4px 4px 0 0;
			text-decoration: none;
		}

		&-item:hover {
			background-color: rgb(255, 255, 255, 0.6);
		}

		&-item:not(:last-child) {
			margin-right: 1px;
		}

	}
	.router-link-exact-active {
		color: rgb(var(--v-theme-text900));
		background-color: #ffffff !important;
	}
}
</style>
